// extracted by mini-css-extract-plugin
module.exports = {"introSection":"project-module--introSection--1StE4","introDescription":"project-module--introDescription--2tdv_"};